module.exports = __webpack_public_path__ + "media/4.bddaeb97.mp3";